<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('审核状态')">
                <a-select v-model="queryParam.auditStatus" :placeholder="$t('请选择审核状态')">
                  <a-select-option v-for="data in auditStatusList" :key="data.key" :value="data.key">
                    {{data.title}}
                  </a-select-option>
                </a-select>
              </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>-->
      <a-button type="primary" icon="download" @click="handleExportXls($t('我的申请'))">{{ $t('导出') }}</a-button>
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
        >

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="auditStatusSlot" slot-scope="text">
          <a-button :class="text == 2?'normalbg-status':text == 1?'unusualbg-status':'unactivebg-status'">
            {{text==2?$t('审核通过'):text==1?$t('审核不通过'):$t('待审核')}}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <!--
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          -->
        </span>

      </a-table>
    </div>

    <user-apply-record-modal ref="modalForm" @ok="modalFormOk"></user-apply-record-modal>
  </a-card>
</template>

<script>

  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import UserApplyRecordModal from './modules/UserApplyRecordModal'

  export default {
    name: 'AuditRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      UserApplyRecordModal
    },
    data () {
      return {
        description: this.$t('audit_record管理页面'),
        url: {
          list: "/auditprocess/auditRecord/getMyApply",
          delete: "/auditprocess/auditRecord/delete",
          deleteBatch: "/auditprocess/auditRecord/deleteBatch",
          exportXlsUrl: "/auditprocess/auditRecord/exportMyApplyXls",
          importExcelUrl: "auditprocess/auditRecord/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            customRender: (t,r,index) => {
              if(r.vocationDetail) {
                let vocationDetail = JSON.parse(r.vocationDetail);
                if(vocationDetail&&vocationDetail.userName) {
                  return vocationDetail.userName;
                }
              }
              return '--';
            }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            customRender: (t,r,index) => {
              if(r.vocationDetail) {
                let vocationDetail = JSON.parse(r.vocationDetail);
                if(vocationDetail&&vocationDetail.userId) {
                  return vocationDetail.userId;
                }
              }
              return '--';
            }
          },
          {
            title: this.$t('补水金额(元)'),
            align:"center",
            dataIndex: 'buyWaterMoney',
            customRender: (t,r,index) => {
              if(r.vocationDetail) {
                let vocationDetail = JSON.parse(r.vocationDetail);
                if(vocationDetail&&vocationDetail.buyWaterMoney) {
                  return vocationDetail.buyWaterMoney;
                }
              }
              return '--';
            }
          },
          {
            title: this.$t('申请时间'),
            align:"center",
            dataIndex: 'createTime',

          },/*
          {
            title:'业务申请名称',
            align:"center",
            dataIndex: 'vocationTitle'
          },*/
          {
            title: this.$t('审核状态'),
            align:"center",
            dataIndex: 'auditStatus',
            scopedSlots: { customRender: 'auditStatusSlot' },
          },
          /*
          {
            title:'业务办理类型(3为补水审核)',
            align:"center",
            dataIndex: 'vocationType'
          },
          */
          {
            title: this.$t('审核人员'),
            align:"center",
            dataIndex: 'auditorName'
          },
          {
            title: this.$t('审核时间'),
            align:"center",
            dataIndex: 'auditTime',

          },

          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      auditStatusList() {
        return [
          {key: 0,title: this.$t('待审核')},
          {key: 1,title: this.$t('审核不通过')},
          {key: 2,title: this.$t('审核通过')},
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      handleDetail:function(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title=this.$t('补水审核详情');
        this.$refs.modalForm.disableSubmit = true;
      },
    }
  }
</script>
<style scoped>
</style>